import ApiService from '@/services/ApiService';

class PropertiesVisitService {
  static async getCalendarConfig({ propertyId } = {}) {
    let composedURL = '/api3/booking/config';

    if (propertyId) {
      composedURL += `?property_id=${propertyId}`;
    }

    const response = ApiService.get(composedURL);
    return response;
  }

  static async getCalendarStatus({ propertyId } = {}) {
    let composedURL = '/api3/booking/calendar_status';

    if (propertyId) {
      composedURL += `?property_id=${propertyId}`;
    }

    const response = ApiService.get(composedURL);
    return response;
  }

  static async updateCalendarStatus(data) {
    const { property_id, ...payload } = data;

    if (property_id) {
      payload.property_id = property_id;
    }

    const composedURL = '/api3/booking/calendar_status';
    const response = ApiService.put(composedURL, payload);
    return response;
  }

  static async updateCalendarConfig(data) {
    const { property_id, ...payload } = data;

    if (property_id) {
      payload.property_id = property_id;
    }

    const composedURL = '/api3/booking/config';
    const response = ApiService.post(composedURL, payload);
    return response;
  }

  static async deleteCalendarConfig(data) {
    const { property_id, ...payload } = data;

    if (property_id) {
      payload.property_id = property_id;
    }

    const composedURL = '/api3/booking/config';
    const response = ApiService.delete(composedURL, payload);
    return response;
  }

  static async getVisitEvents(payload) {
    const {
      propertyId,
      page,
      pageSize,
      status,
      contact,
      property,
      fromDate,
      toDate,
      agentIds,
    } = payload;
    let composedURL = `/api3/schedule/events_calendar/?`;

    if (propertyId) {
      composedURL += `property_id=${propertyId}&`;
    }

    composedURL += `page=${page}&page_size=${pageSize}`;

    if (status) composedURL += `&status=${status}`;
    if (contact) composedURL += `&contact_name=${contact}`;
    if (property) composedURL += `&property_id=${property}`;
    if (fromDate) composedURL += `&start_date=${fromDate}`;
    if (toDate) composedURL += `&end_date=${toDate}`;
    if (agentIds?.length) {
      agentIds.forEach((agentId) => {
        composedURL += `&agent_ids=${agentId}`;
      });
    }

    const response = ApiService.get(composedURL);
    return response;
  }

  static async getEventTypesList(propertyId) {
    let composedURL = `/api3/booking/visit_events/`;

    if (propertyId) {
      composedURL += `?propertyId=${propertyId}`;
    }

    const response = ApiService.get(composedURL);
    return response;
  }

  static async getAgents(q) {
    const composedURL = `/api3/agent/?q=${q}`;
    const response = ApiService.get(composedURL);
    return response;
  }

  static async getContacts(q) {
    const composedURL = `/api3/contact/?q=${q}`;
    const response = ApiService.get(composedURL);
    return response;
  }

  static async getProperties(q) {
    const composedURL = `/api3/property?q=${q}`;
    const response = ApiService.get(composedURL);
    return response;
  }

  static async cancelVisit(data) {
    const { property_id, ...payload } = data;

    if (property_id) {
      payload.property_id = property_id;
    }

    const composedURL = '/api3/schedule/event/schedule_visit';
    const response = ApiService.delete(composedURL, payload);
    return response;
  }

  static async getTimeline(visitId) {
    const composedURL = `/api3/booking/timeline/?identifier=${visitId}`;
    const response = ApiService.get(composedURL);
    return response;
  }

  static async getProperty(propertyId) {
    const composedURL = `/api3/property/${propertyId}/quick`;
    const response = ApiService.get(composedURL);
    return response;
  }

  static async createContact(payload) {
    const composedURL = '/api3/contacts';
    const response = ApiService.post(composedURL, payload);
    return response;
  }

  static async deletePropertyConfiguration(payload) {
    const composedURL = `/api3/booking/property/config`;
    const response = ApiService.delete(composedURL, payload);
    return response;
  }

  static async getVisitData(visitId) {
    const composedURL = `/api3/schedule/visit_info/${visitId}/`;
    const response = ApiService.get(composedURL);
    return response;
  }
}

export default PropertiesVisitService;
